import { Injectable } from '@angular/core';
import { Events, HorasExtraActiva, JornadaAnterior, PausaFinalizada, PausasActivas, PermisosActivos, PermisoDelDiaFinalizado, EventDatum, MetaDatum } from '../interfaces/schedule.interface';
import { ClosedSubEvent, EventNeo, MetaNeo, OpenSubEvent, PreviousWorkDay, UserLoggedFromEvent, WorkerCurrent } from '../interfaces/ficha.interface';

@Injectable({
  providedIn: 'root'
})
export class FichaJsonBuildService {

  eventsNeo(events:Events|undefined){ // :EventsNeo
    if(events === undefined) return
    return {
      meta: this.setMetaNeo(events),
      data: this.setEventNeoArr(events.data),
    }

  }

  // #region BUILD META NEO

  private setMetaNeo(events:Events):MetaNeo{
    const metaDatum = (events.meta ?? {}) as Partial<MetaDatum>;
    const eventsDatum = Array.isArray(events.data) ? events.data : [];

    const metaNeoBuild:MetaNeo = {
      // FICHA SETTINGS
      previous_work_day: !metaDatum.jornada_anterior ? null : this.setMetaPreviousWorkDay(metaDatum.jornada_anterior),
      previous_work_day_without_clocking: !!metaDatum.evento_anterior_sin_fichaje,

      // FICHA STATES
      open_leave:    !metaDatum.permisos_del_dia_activos ? null : this.setMetaOpenLeave(metaDatum.permisos_del_dia_activos),
      open_overtime: !metaDatum.horas_extras_activas ? null : this.setMetaOpenOverTime(metaDatum.horas_extras_activas),
      open_pause:    !metaDatum.pausas_activas ? null : this.setMetaOpenPause(metaDatum.pausas_activas),

      // a cada EVENT
      closed_leaves:  this.setMetaClosedLeaveArr(metaDatum.permisos_del_dia_finalizados ?? []),
      closed_pauses:   this.setMetaClosedPauseArr(metaDatum.pausas_finalizadas ?? []),

      // nuevos //!pending move source from here to worker_current
      company_id:      metaDatum.company_id ?? 0,
      worker_dni:      metaDatum.dni ?? '',
      worker_name:     metaDatum.name ?? '',

    };
    const evDatum = eventsDatum.length > 0 ? eventsDatum[0] : undefined
    metaNeoBuild.worker_current = this.setWorkerCurrent(metaDatum, evDatum )
    if (eventsDatum.length > 0){
      const capabilities = this.setMetaUserLoggedFromEvent(eventsDatum[0]);
      metaNeoBuild.capabilities = capabilities;

    }

    return metaNeoBuild;
  }
  private setMetaPreviousWorkDay(jornadaAnterior:JornadaAnterior):PreviousWorkDay {
    return {
      // id_unico:             jornadaAnterior.id_unico,
      uuid:                 jornadaAnterior.uuid,
      event_start_expected: this.convertToLocalISOFormat(jornadaAnterior.date_start),
      event_end_expected:   this.convertToLocalISOFormat(jornadaAnterior.date_end),
    }
  }
  private setMetaOpenLeave(permisosDelDiaActivos:PermisosActivos):OpenSubEvent {
    return {
      id:                 Number.parseInt(permisosDelDiaActivos.id),
      schedule_id:        permisosDelDiaActivos.schedule_id ? +permisosDelDiaActivos.schedule_id : +permisosDelDiaActivos.shedule_id,
      // motivo_request_id:  parseInt(permisosDelDiaActivos.motivo_id),
      motivo_id:          Number.parseInt(permisosDelDiaActivos.motivo_id),
      date_in:            permisosDelDiaActivos.selected_days+' '+permisosDelDiaActivos.timeStart,
      motivo_request:     permisosDelDiaActivos.nombre,
      comment:            permisosDelDiaActivos.comments, //! revisar si realmente viene

      // event_start_map_img:  null,
      // event_start_latitud:  null,
      // event_start_longitud: null,
    }
  }
  private setMetaOpenOverTime(horasExtraActivas:HorasExtraActiva):OpenSubEvent {
    return {
      id:                 horasExtraActivas.id,
      schedule_id:        horasExtraActivas.schedule_id,
      // motivo_request_id:  horasExtraActivas.request_id,
      request_id:         horasExtraActivas.request_id,
      date_in:            horasExtraActivas.day+' '+horasExtraActivas.date_start,
      motivo_request:     horasExtraActivas.comments,
      // comment:            '',

      event_start_map_img:  horasExtraActivas.mapa_in,
      event_start_latitud:  horasExtraActivas.latitude_in,
      event_start_longitud: horasExtraActivas.longitude_in,
    }
  }
  private setMetaOpenPause(pausasActivas:PausasActivas):OpenSubEvent {
    return {
      id:                 parseInt(pausasActivas.id),
      schedule_id:        parseInt(pausasActivas.shedule_id),
      // motivo_request_id:  parseInt(pausasActivas.motivo_id),
      motivo_id:          parseInt(pausasActivas.motivo_id),
      date_in:            pausasActivas.hora_entrada,
      motivo_request:     pausasActivas.motivo,
      comment:            pausasActivas.comentario,
    }
  }
  private setMetaClosedLeaveArr(permisosFinalizados:PermisoDelDiaFinalizado[]):ClosedSubEvent[] {
    const leaveArr = [];
    if (permisosFinalizados.length > 0) {
      for (const el of permisosFinalizados) {
        leaveArr.push ({
          id:                 el.id,
          schedule_id:        el.schedule_id ?? el.shedule_id ??  0,
          // motivo_request_id:  el.request_id,
          request_id:         el.request_id,
          //! PENDIENTE API v2: usar check_in_at (fichaje real) NO starts_at (planificado). Backend corrigiendo bug de nomenclatura. Ver PermisoV2 en scheadule-v2.interface.ts
          date_in:            el.check_in_at ?? el.date_in,     // this.convertToLocalISOFormat(el.date_in),
          //! PENDIENTE API v2: usar check_out_at (fichaje real) NO ends_at (planificado). Mismo bug.
          date_out:           el.check_out_at ?? el.date_out,    // this.convertToLocalISOFormat(el.date_out),
          date_start:         el.starts_at ?? el.date_start,  // this.convertToLocalISOFormat(el.date_start),
          date_end:           el.ends_at ?? el.date_end,    // this.convertToLocalISOFormat(el.date_end),
          motivo_request:     el.reason?.name ?? el.permiso_motivo_nombre,
          comment:            el.comentario_permiso,

          elapsed_minutes:  el.duration_minutes ?? el.tiempo_real,
          //! PENDIENTE API v2: attached_img y attached_pdf dejan de ser URLs y pasan a ser conteos numéricos (attachments.images / attachments.pdfs). Revisar consumidor que use estas URLs antes de migrar.
          attached_img:     el.imagen_permiso,
          attached_pdf:     el.pdf_permiso,
        })
      }
    }
    return leaveArr
  }
  private setMetaClosedPauseArr(pausasFinalizadas:PausaFinalizada[]):ClosedSubEvent[] {
    const pauseArr = [];
    if (pausasFinalizadas.length > 0) {
      for (const el of pausasFinalizadas) {
        pauseArr.push ({
          id:                 Number.parseInt(el.pausa_id),
          schedule_id:        el.schedule_id ?? el.shedule_id ??  0,
          // motivo_request_id:  parseInt(el.pausa_motivo_id),
          motivo_id:          Number.parseInt(el.pausa_motivo_id),

          motivo_request:     el.reason?.name ?? el.pausa_motivo,
          comment:            el.comentario_pausa,

          //! PENDIENTE API v2: usar check_in_at / check_out_at (fichaje real) NO starts_at / ends_at (planificado). Backend corrigiendo bug de nomenclatura. Ver PausaV2 en scheadule-v2.interface.ts
          date_in:      el.starts_at ?? el.hora_entrada,
          date_out:     el.ends_at ?? el.hora_salida,

          elapsed_seconds: el.duration_seconds ?? el.segundos,
        })
      }
    }
    return pauseArr
  }
  private setWorkerCurrent(mt:Partial<MetaDatum>, ev?:EventDatum):WorkerCurrent { //!pending move source from event to meta
    return {
      // de EVENT a META
      worker_id:    ev?.worker_id ?? 0,

      worker_name:  mt.name ?? '',
      company_id:   mt.company_id ?? 0,
      worker_dni:   mt.dni ?? '',
      company_name: 'company name pending'
    }
  }
  private setMetaUserLoggedFromEvent(ev:EventDatum):UserLoggedFromEvent {
    return {
      // de EVENT a USER LOGGEDmodificar_permisos
      is_informe_firmado:   ev.informe_firmado,
      pauses_computable:    ev.pausa_computable,
      require_signature:   ev.firma_requerida,
      require_location:    ev.mapa_requerido_fichar,
      allow_remote_work:  ev.teletrabajo_dia,
      allow_location:       ev.include_location,
      allow_change_permisos: ev.modificar_permisos,
      // allow_teletrabajo:    ev.teletrabajo_activo,
      allow_overtime:       ev.horas_extras_jornada,
      allow_pause:          ev.pausas,
      allow_leave:          ev.permisos_retribuidos_jornada,
      allow_full_day_leave: ev.permiso_dia_completo,

      allow_event_start_limit_adjustment: ev.ajuste_fichaje_entrada,
      allow_event_end_limit_adjustment:   ev.ajuste_fichaje,
      allow_free_work: false,
      allow_clock_without_schedule: false,
      allow_web_access: false,
    }
  }
  //#endregion


  // #region BUILD EVENTS NEO

  private setEventNeoArr(eventsDatum:EventDatum[]){
    if (eventsDatum.length < 1) return [];
    const eventNeoArrBuild:EventNeo[] = [];
    for (const ev of eventsDatum) {
      const evBuild = {
        // EVENT IDS
        id:                    ev.id,
        schedule_rule_id:      ev.horario_id,
        schedule_rule_line_id: ev.horario_linea_id,
        company_id:            ev.company_id,
        company_short_name:    ev.short_name,

        // EVENT TYPE
        type:             ev.type,
        is_flexible:      ev.es_flexible,
        type_of_flexible: ev.tipo_flexible,
        show_estimate:    ev.mostrar_estimadas,
        is_night_shift:   ev.es_nocturno,
        is_overtime:      ev.hora_extra,

        event_start_adjusted_by_management: ev.entrada_ajustada,
        event_adjusted_by_request:          ev.es_ajuste,

        // EVENT START
        event_start_clock_in:   ev.date_in, // string
        event_start_expected:   ev.date_start, // string
        event_start_tolerance:  ev.issue_time,
        event_start_control:    ev.entrance_time,
        event_start_limit:      ev.limite_entrada,

        // EVENT END
        event_end_clock_out:  ev.date_out, // string
        event_end_expected:   ev.date_end, // string
        event_end_tolerance:  ev.issue_time_exit,
        event_end_control:    ev.issue_time_exit, //! por ahora control y tolerancia de salida son iguales
        event_end_limit:      ev.exit_time,

        // EVENT WORKING HOURS
        working_hours_penalty:   ev.penalizacion,
        working_hours_tolerance: ev.cortesia,
        working_hours_clocked:   ev.tiempo_real,
        working_hours_expected:  ev.tiempo_previsto,

        //! deberian fusionarse con expected
        working_hours_expected_overtime:  ev.tiempo_extra,
        working_hours_expected_default:   ev.jornada_estimada,


        // EVENT LOCATION
            //    event start
        event_start_location_prone_name: ev.estacion_alias_in, // string | null
        event_start_location_map_img:    ev.mapa_in, // string | null
        event_start_location_longitud:   ev.longitude_in, // number | null
        event_start_location_latitud:    ev.latitude_in, // number | null
        event_start_location_bio_name:   ev.location_in_alias, // string | null
            //    event end
        event_end_location_prone_name:   ev.estacion_alias_out, // string | null
        event_end_location_map_img:      ev.mapa_out, // string | null
        event_end_location_longitude:    ev.longitude_out, // number | null
        event_end_location_latitude:     ev.latitude_out, // number | null
        event_end_location_bio_name:     ev.location_out_alias, // string | null

        // SUB EVENTS
        lunch:        ev.tiempo_comida, // number
        pauses_limit: ev.pausa_limite, // number

        // SUMMARY ELEMENTS
        attachments:          ev.adjuntos,
        img_number:           ev.images_permisos,
        pdfs_number:          ev.pdf_permisos,
        signature_img:        ev.firma, // string
        remote_work:          ev.teletrabajo,

        // EVENT CLIENT ASSIGN
        client_assign_name: ev.cliente_name, // string
        client_assign_id:   ev.cliente_id, // number

        // EVENT END
        instructions_by_management:   ev.description, // string

        incidence_code: ev.tipo_incidencia,

        incidence_clock_in_id:       ev.issue_id_entrada, // number
        incidence_clock_in_reason:   ev.motivo_incidencia_entrada, // string
        incidence_clock_in_comment:  ev.comentario_incidencia_entrada, // string

        incidence_clock_out_id:      ev.issue_id_salida, // number
        incidence_clock_out_reason:  ev.motivo_incidencia_salida, // string
        incidence_clock_out_comment: ev.comentario_incidencia_salida, // string

        incidence_working_hours_id:      ev.issue_id_jornada, // number
        incidence_working_hours_reason:  ev.motivo_incidencia_jornada, // string
        incidence_working_hours_comment: ev.comentario_incidencia_jornada, // string
      }
      eventNeoArrBuild.push(evBuild)
    }

    return eventNeoArrBuild;
  }


  // ######## HELPER FUNCTIONS ########

  private convertToLocalISOFormat(dateStr: string|undefined): string {
    //? ######### CONVERTS dd-mm-yyyy hh:mm.nnnn => yyyy-MM-dd HH:mm:ss #########
    if (!dateStr) {
      console.error('date missing');
      return ''
    }

    // Split date and time
    const [datePart, timePart] = dateStr.split(' ');

    // Map date structure received to variables, we could improve this to accept more fromats.
    const [day, month, year] = datePart.split('-').map(Number);

    // Split time and ignore milliseconds
    const [time, _] = timePart.split('.');
    const [hour, minute] = time.split(':').map(Number);

    // Create date object in local time
    const dateObj = new Date(year, month - 1, day, hour, minute);

    // Format components to always have two digits
    const pad = (n: number) => n.toString().padStart(2, '0');

    const formattedDate = `${year}-${pad(month)}-${pad(day)} ${pad(hour)}:${pad(minute)}:${pad(dateObj.getSeconds())}`;

    return formattedDate;
  }

}
